import React from "react";
import { Container, Row, Col, CardBody, Card } from "reactstrap";
import { Link } from "react-router-dom";
import { digitalMarketing } from "../design/DummyData";
import "../../sass/design.scss";
import FAQAccordion from "../../../components/FAQAccordion";
import TextSlicer from "../../../components/TextSlicer";
import MetaData from "../../../components/MetaData";
import GoogleReviewSection from "../../../components/GoogleReviewSection";

const digitalMarketingFaq1 = [
  "It is a type of marketing that is focused on digital devices like tablets, laptops, smartphones, and much more.",
  "You can use this marketing for any device that is connected to Wi-Fi.",
  "It is better than traditional marketing that includes print, film, radio, and TV.",
  "In digital marketing, the focus is mainly on blogs, websites, social media platforms, and email.",
];

const digitalMarketingFaq2 = [
  "Digital marketing is very much essential and far better than traditional marketing.",
  "It provides more opportunities to grab the attention of your targeted audience.",
  "It helps convert visitors into potential leads.",
  "You can use digital marketing as a powerful tool to improve your business sales and ROI.",
];

const digitalMarketingFaq3 = [
  "Founder / Managing Director",
  "Account Manager",
  "UI Designer",
  "Graphic Designer",
  "Web Developer",
  "Social Media Marketer",
  "Copywriter",
];

const digitalMarketingFaq4 = [
  "Technical SEO audit is a compulsory process to diagnose how search engines respond to your website.",
  "It helps evaluate website visibility, functionality, and speed in search engine results.",
  "Google is the leading search engine, so brands try to rank higher to attract potential customers.",
  "SoftoRithm Technologies performs deep crawls to detect issues like broken links, indexing errors, and slow-loading assets.",
  "Our experts optimize your website according to SEO guidelines to improve search engine rankings.",
];

const digitalMarketingFaq5 = [
  "Billions of searches happen globally and about 95% are performed on Google.",
  "If your website is not optimized, you may miss potential customers.",
  "SEO requires time, effort, and continuous optimization.",
  "Our experts analyze your website and identify issues affecting your ranking.",
  "We provide monthly, quarterly, and yearly SEO support to improve your online visibility.",
];

const digitalMarketingFaq6 = [
  "If you are not getting enough leads, our PPC experts can help.",
  "We perform a full audit including ad copy analysis and keyword integration.",
  "We help optimize ad campaigns to make them more profitable.",
  "Our team manages ads on Google, Meta, TikTok, Twitter, and LinkedIn to increase leads.",
];

const digitalMarketingFaq7 = [
  "SoftoRithm Technologies has many years of experience as a digital marketing agency.",
  "We bring experts from different fields under one roof.",
  "Our goal is to provide high-quality and satisfactory services to our clients.",
  "If you are unsure, contact us and we will guide you in choosing the best solution for your business.",
];

const summary = `In summary, small to large or multinational companies contact Softorithm for a comprehensive suite of SEO services (on-page and off-page) and SEM, leveraging the company's expertise, customization, and commitment to delivering measurable results.
`;

const DigitalMarketing = () => {
  const handleButtonClick = () => {
    // Handle button click - you can navigate to a specific page or perform any action
    console.log("See Our Work button clicked");
  };

  return (
    <div className="design">
      <MetaData
        metaTitle={"Digital Marketing"}
        metaDescription={
          "At Softorithm, we pride ourselves on providing exceptional web development, graphic design, UI/UX design, and digital marketing services through our team of passionate professionals."
        }
      />

      {/* Section 1 - Hero with Google Review */}
      <GoogleReviewSection
        title="Digital Marketing Services"
        subtitle="Professional digital marketing services built to attract customers, boost your search rankings, and grow your business. Trusted by companies across the UK for over 12 years."
        buttonText="See Our Work"
        onButtonClick={handleButtonClick}
        companyName="Softorithm"
      />

      <div className="page_body">
        <div className=" mt-5">
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="text-center mb-4 pb-2 about_rgt_cont">
                <h4 className="fw-semibold fs-22 mb-4">
                  Digital Visibility Means More Leads for Your Business
                </h4>
                <TextSlicer
                  text={`Digital marketing! In this process, we try to enclose all the marketing efforts that are connected to the digital space. We will also cover different digital channels like social media marketing, search engine optimization, websites optimization, and email marketing. The different avenues of digital marketing are useful when a business wants to generate leads, and potentially a sale.`}
                />
                <TextSlicer
                  text={`Planning to improve your digital marketing strategy to trigger your business sales? Well, digital marketing is one of the best tools that you can use for your business. You just need to harness its power in the right way to achieve your business goals. To get the digital marketing services at an affordable price with great results, connect with SoftoRithm Technologies without any delay. `}
                />
                {/* <p className="text-muted mb-4 fs-15">
                 </p> */}
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xl={9}>
              <Row className="justify-content-center">
                {(digitalMarketing || []).map((price2, key) => (
                  <Col md={6} lg={4} xl={4} key={key}>
                    <Card className="pricing-box ribbon-box right">
                      <CardBody className="p-4 m-2">
                        <div className="d-flex align-items-start">
                          <div className="flex-grow-1 me-3">
                            <h5 className="mb-1 fw-semibold">{price2.type}</h5>
                            <p className="text-muted mb-0">{price2.purpose}</p>
                          </div>
                          <div className="avatar-sm flex-shrink-0">
                            <div className="avatar-title bg-light rounded-circle text-primary">
                              <i className={"fs-20 " + price2.icon}></i>
                            </div>
                          </div>
                        </div>

                        <hr className="my-4 text-muted" />
                        <div className="scrollable-list">
                          <ul className="list-unstyled text-muted vstack gap-3">
                            {(price2.points || []).map((point, key) => (
                              <li key={key}>
                                <div className="d-flex">
                                  <div className="flex-shrink-0 text-success me-1">
                                    <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                  </div>
                                  <div className="flex-grow-1">{point}</div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="mt-3 pt-2">
                          <Link
                            to="/contact-us"
                            className={`btn btn-success w-100`}
                          >
                            Get Quote
                          </Link>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* Section 7 - CTA Section */}
          <section className="erp_cta_section">
            <Container>
              <Row className="align-items-center">
                <Col lg={8} md={7} sm={12} className="mb-3 mb-md-0">
                  <p className="erp_cta_text">
                    Would you like to connect and engage with your audience?
                  </p>
                </Col>
                <Col lg={4} md={5} sm={12} className="text-center text-md-start">
                  <button
                    type="button"
                    className="erp_cta_btn"
                    onClick={handleButtonClick}
                  >
                    Call Us Today!
                  </button>
                </Col>
              </Row>
            </Container>
          </section>

          <div className="container mt-5">
            <div
              className="faq_section py-3"
              style={{ backgroundColor: "var(--body-bg-color, #f8f9fa)" }}
            >
              <Container>
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <div className="faq_header text-center mb-5">
                      <h2 className="mb-3">Frequently Asked Questions</h2>
                    </div>
                    <FAQAccordion
                      faqData={[
                        {
                          question: "What is digital marketing?",
                          points: digitalMarketingFaq1,
                        },
                        {
                          question:
                            "How digital marketing will be beneficial for my business?",
                          points: digitalMarketingFaq2,
                        },
                        {
                          question:
                            "Who are the players in a digital marketing agency?",
                          points: digitalMarketingFaq3,
                        },
                        {
                          question:
                            "How Much Technical SEO Audits are Important for Your Website SERP Ranking?",
                          points: digitalMarketingFaq4,
                        },
                        {
                          question:
                            "How can your business expect ongoing support and analysis from us to stay competitive in off-page SEO?",
                          points: digitalMarketingFaq5,
                        },
                        {
                          question:
                            "How can our SEM services significantly improve your website's visibility on search engines?",
                          points: digitalMarketingFaq6,
                        },
                        {
                          question: "Why are we the right pick?",
                          points: digitalMarketingFaq7,
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalMarketing;
